import { createSelector } from "@reduxjs/toolkit";
const calculatePossiblePayout = createSelector(
  (value) => Number(value),
  (value, coefficient) => coefficient,
  (value, coefficient) => value && coefficient ? (value * 100 * coefficient / 100).toFixed(2) : "0"
);
const calculatePossibleWinningsGain = createSelector(
  (value) => +value,
  (_value, coefficient) => coefficient,
  (value, coefficient) => {
    if (!value || !coefficient) return 0;
    const possible = value * 100 * coefficient / 100;
    if (possible <= 0) return 0;
    return possible - value;
  }
);
const calculatePossibleWinningsBase = createSelector(
  (value) => value,
  (_value, coefficient) => coefficient,
  (value, _coefficient) => +value
);
const calculatePossibleWinningsFull = createSelector(
  (value) => +value,
  (_value, coefficient) => coefficient,
  (value, coefficient) => {
    if (!value || !coefficient) return 0;
    return value * 100 * coefficient / 100;
  }
);
const calculateTotals = createSelector(
  (values) => values.filter((value) => !!value).map((value) => 100 * Number(value)),
  (values) => (values.reduce((a, b) => a + b, 0) / 100).toFixed(2)
);
const calculateWithholdingTaxFromPayout = createSelector(
  (possiblePayout) => possiblePayout,
  (possiblePayout, stakeAmount) => +stakeAmount,
  (possiblePayout, stakeAmount, tax) => tax,
  (possiblePayout, stakeAmount, tax) => {
    if (!possiblePayout) return 0;
    return Math.abs((possiblePayout - stakeAmount) * (tax / 100));
  }
);
const calculatePossibleWinningAfterTax = createSelector(
  (possiblePayout) => Number(possiblePayout),
  (possiblePayout, withholdingTax) => Number(withholdingTax),
  (possiblePayout, withholdingTax) => {
    if (!possiblePayout || !withholdingTax) return 0;
    return possiblePayout - withholdingTax;
  }
);
const calculateStakeAfterTax = createSelector(
  (stake) => Number(stake),
  (stake, tax) => tax,
  (stake, tax) => {
    if (stake && tax) {
      return stake * 100 / (100 + tax);
    }
    return stake;
  }
);
const convertToCurrency = createSelector(
  (value) => value,
  (value, rate) => rate,
  (value, rate) => value * rate
);
const convertFromCurrency = createSelector(
  (value) => value,
  (value, rate) => rate,
  (value, rate) => value / rate
);
export {
  calculatePossiblePayout,
  calculatePossibleWinningAfterTax,
  calculatePossibleWinningsBase,
  calculatePossibleWinningsFull,
  calculatePossibleWinningsGain,
  calculateStakeAfterTax,
  calculateTotals,
  calculateWithholdingTaxFromPayout,
  convertFromCurrency,
  convertToCurrency
};
